import { gql } from "@apollo/client";
import { useState } from "react";
import { useQuery } from "@apollo/client";
import useAuth from "~/src/auth/hooks/use-auth";
import { checkErrors } from "~/src/utils/errors";
import { PayrollRate } from "../types";

type dataType = {
  account: {
    payrollRates: PayrollRate[];
  };
};

export const GET_PAYROLL_RATES = gql`
  query payrollRates($search: String, $offset: Int!, $limit: Int!) {
    account {
      id
      payrollRates(search: $search, offset: $offset, limit: $limit) {
        id
        name
        config
        createdAt
        updatedAt
      }
    }
  }
`;

const PAGE_SIZE = 200;

export const usePayrollRates = (searchText: string) => {
  const auth = useAuth();
  const [isInitialFetch, setIsInitialFetch] = useState(true);
  const [limit, setLimit] = useState(PAGE_SIZE);
  const [offset, setOffset] = useState(0);

  const { loading, data, fetchMore } = checkErrors(
    useQuery(GET_PAYROLL_RATES, {
      variables: auth.addVals(GET_PAYROLL_RATES, {
        search: searchText,
        offset,
        limit
      }),
      fetchPolicy: isInitialFetch ? "network-only" : "cache-first",
      notifyOnNetworkStatusChange: true
    })
  );

  const payrollRates = data?.account?.payrollRates ?? [];
  const totalResults = payrollRates.length;

  return {
    loading: isInitialFetch && loading,
    loadingMore: !isInitialFetch && loading,
    payrollRates,
    hasMore: payrollRates.length < totalResults,
    fetchMore: () => {
      if (payrollRates.length < totalResults) {
        setIsInitialFetch(false);
        const newOffset = offset + limit;
        setOffset(newOffset);

        fetchMore({
          variables: {
            offset: newOffset,
            limit: PAGE_SIZE
          },
          fetchPolicy: "network-only"
        }).then(({ data }: { data: dataType }) => {
          setLimit(limit + data.account.payrollRates.length);
        });
      }
    }
  };
};
